export const pagesPlacesLaborCoreEn = {
  navigation: {
    socialInsuranceBasic: "Social Insurance Basic",
    healthInsurance: "Health Insurance",
    pensionInsurance: "Pension Insurance",
    employmentInsurance: "Employment Insurance",
    workersCompensation: "Workers' Compensation",
    incomeTax: "Income Tax",
    localTax: "Local Tax",
  },
  common: {
    edit: "Edit",
  },
  socialInsuranceBasic: {
    title: "Social Insurance Basic",
    fields: {
      socialInsuranceName: "Social Insurance Name",
      socialInsuranceNameKana: "Social Insurance Name (Kana)",
      identificationName:
        "Identification Name (Name not displayed in documents for identification purposes)",
      phoneNumber: "Phone Number",
      representative: "Representative",
      representativeTitle: "Representative Title",
      address: "Address",
      addressKana: "Address (Kana)",
    },
  },
  healthInsurance: {
    title: "Health Insurance",
    fields: {
      type: "Type",
      name: "Name",
      officeReferenceNumber: "Office Reference Number",
      healthInsuranceOffice: "Health Insurance Office",
      healthInsuranceAssociation: "Health Insurance Association",
      addHealthInsuranceAssociationLink:
        "Edit society type and name in People > Settings",
      selectHealthInsuranceAssociation:
        "Select Health Insurance Association...",
      healthInsuranceReportingDestination:
        "Health Insurance Reporting Destination",
    },
  },
  pensionInsurance: {
    title: "Pension Insurance",
    fields: {
      officeReferenceNumber: "Office Reference Number",
      officeNumber: "Office Number",
      pensionInsuranceOffice: "Pension Insurance Office",
    },
  },
  employmentInsurance: {
    title: "Employment Insurance",
    fields: {
      officeNumber: "Office Number",
      publicEmploymentStabilityOffice: "Public Employment Office (Hello Work)",
    },
  },
  workersCompensation: {
    title: "Workers' Compensation",
    fields: {
      officeNumber: "Office Number",
      laborInspectionOffice: "Labor Inspection Office",
    },
  },
  incomeTax: {
    title: "Income Tax",
    fields: {
      taxOfficeCode: "Tax Office Code",
      taxOfficeName: "Tax Office Name",
    },
  },
  localTax: {
    title: "Local Tax",
    fields: {
      specialCollectionNumber: "Special Collection Number",
      representativeDepartment: "Representative - Department",
      representativeName: "Representative - Name",
      representativeNameKana: "Representative - Name (Kana)",
      representativePhoneNumber: "Representative - Phone Number",
    },
  },
};
